/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiStreamingQueueMessage,
    ApiStreamingQueueMessageFromJSON,
    ApiStreamingQueueMessageFromJSONTyped,
    ApiStreamingQueueMessageToJSON,
} from './ApiStreamingQueueMessage';
import {
    RuntimeStreamError,
    RuntimeStreamErrorFromJSON,
    RuntimeStreamErrorFromJSONTyped,
    RuntimeStreamErrorToJSON,
} from './RuntimeStreamError';

/**
 * 
 * @export
 * @interface StreamResultOfApiStreamingQueueMessage
 */
export interface StreamResultOfApiStreamingQueueMessage {
    /**
     * 
     * @type {RuntimeStreamError}
     * @memberof StreamResultOfApiStreamingQueueMessage
     */
    error?: RuntimeStreamError;
    /**
     * 
     * @type {ApiStreamingQueueMessage}
     * @memberof StreamResultOfApiStreamingQueueMessage
     */
    result?: ApiStreamingQueueMessage;
}

export function StreamResultOfApiStreamingQueueMessageFromJSON(json: any): StreamResultOfApiStreamingQueueMessage {
    return StreamResultOfApiStreamingQueueMessageFromJSONTyped(json, false);
}

export function StreamResultOfApiStreamingQueueMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreamResultOfApiStreamingQueueMessage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'error': !exists(json, 'error') ? undefined : RuntimeStreamErrorFromJSON(json['error']),
        'result': !exists(json, 'result') ? undefined : ApiStreamingQueueMessageFromJSON(json['result']),
    };
}

export function StreamResultOfApiStreamingQueueMessageToJSON(value?: StreamResultOfApiStreamingQueueMessage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'error': RuntimeStreamErrorToJSON(value.error),
        'result': ApiStreamingQueueMessageToJSON(value.result),
    };
}

